import { Box, Card, CardContent, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { useShowContext } from "ra-core";
import { FC } from "react";
import { RecPatch } from "~/dataProvider/tools";
import { BackupDashboardResponseDto } from "~/gen/api/backup";
import { GreenJobs, RedJobs, YellowJobs } from "./statusBadge";

const DashboardStatusCard: FC = () => {
  const { record } = useShowContext<BackupDashboardResponseDto & RecPatch>()
  return (
    <Card>
      <CardHeader 
        sx={{ pb: 0 }}
        title={(
          <Typography variant="h6" color="textPrimary">
            Status Today
          </Typography>
        )}
      />
      <CardContent>
        <Divider sx={{ mb: 1 }} />
        <Box>
          <Typography
            color="textSecondary"
            variant="overline"
          >
            Backup Jobs
          </Typography>
          <Stack 
            component="ul"
            direction="row"
            sx={{ pl: 'unset', mt: 2, mb: 1, }}
          >
            <GreenJobs count={record?.backupSuccessCount || 0} />
            <YellowJobs count={record?.backupWarningCount || 0} />
            <RedJobs count={record?.backupFailedCount || 0} />
          </Stack>
        </Box>
        {/* <Divider sx={{ mb: 1 }} />
        <Box>
          <Typography
            color="textSecondary"
            variant="overline"
          >
            Hosted Databases
          </Typography>
          <Stack 
            direction="row"
            sx={{ 
              mt: 2,
            }}
          >
            <GreenJobs count={12} />
            <YellowJobs count={12} />
            <RedJobs count={12} />
          </Stack>
        </Box> */}
        <Divider sx={{ mb: 1 }} />
        <Box>
          <Typography
            color="textSecondary"
            variant="overline"
          >
            Validation Jobs
          </Typography>
          <Stack 
            component="ul"
            direction="row"
            sx={{ pl: 'unset', mt: 2, }}
          >
            <GreenJobs count={record?.validationSuccessCount || 0} />
            <YellowJobs count={record?.validationWarningCount || 0} />
            <RedJobs count={record?.validationFailedCount || 0} />
          </Stack>
        </Box>
      </CardContent>
    </Card>
  )
}

export default DashboardStatusCard;
